import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { SECURITY_TIP_GROUPS } from 'app/modules/shared/containers/security-tips/security-tips.data';

/** The security tips: the measures a user can take themselves (BSI TR-03161-2 O.Plat_8, O.Resi_1). */
@Component({
    selector: 'security-tips-dialog',
    imports: [MatDialogModule, MatButtonModule, TranslocoModule],
    templateUrl: './security-tips-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class SecurityTipsDialogComponent {
    readonly groups = SECURITY_TIP_GROUPS;
}
